import { PayloadAction, createSlice } from "@reduxjs/toolkit";

type T_LoadingSliceState = {
  showHideLoading?: boolean;
  showOnboardingLoadingText?: boolean;
};

const initialState: T_LoadingSliceState = {
  showHideLoading: false,
  showOnboardingLoadingText: false,
};

export const LoadingSlice = createSlice({
  name: "LoadingSlice",
  initialState: initialState,
  reducers: {
    updateLoadingState: (
      state: T_LoadingSliceState,
      action: PayloadAction<boolean>
    ) => {
      return { ...state, showHideLoading: action.payload };
    },
    updateOnboardingLoadingState: (
      state: T_LoadingSliceState,
      action: PayloadAction<{ loading: boolean; showOnboardingText: boolean }>
    ) => {
      return {
        ...state,
        showHideLoading: action.payload.loading,
        showOnboardingLoadingText: action.payload.showOnboardingText,
      };
    },
  },
});

export const LoadingSliceReducer = LoadingSlice.reducer;
export const LoadingSliceKey = LoadingSlice.reducerPath;
export const { updateLoadingState, updateOnboardingLoadingState } =
  LoadingSlice.actions;
